/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// @mui material components
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import TabPanel from 'components/TabPanel/TabPanel';

// Material Dashboard 2 PRO React examples
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';
import PosReturn from './PosReturn';

function DashboardPosProblem() {
  const mod = 'dashboard_pos';
  const { t, i18n } = useTranslation();
  const app = useSelector((state) => state[APP_STATE]);
  const [record, setRecord] = useState([]);
  const [tab, setTab] = useState(0);

  const changeTab = (event, newValue) => {
    setTab(newValue);
  };

  const view = () => {
    FetchData('POST', `/${mod}/problem`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
        setTab(0);
      } else {
        Func.exitApp();
      }
    });
  };

  const renderCart = () => {
    return (
      <MDBox>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <MDBox>
              <Tabs value={tab} onChange={changeTab} aria-label='wrapped label tabs example'>
                {record.map((row, i) => (
                  <Tab label={`${row.branch_code} (${row.cashier_name})`} value={i} key={row.id} />
                ))}
              </Tabs>
            </MDBox>
            <MDBox className='card' sx={{ borderTop: 0 }}>
              {record.map((row, i) => (
                <TabPanel value={tab} index={i} key={row.id}>
                  <PosReturn parent={row} callback={view} />
                </TabPanel>
              ))}
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    view();
  }, []);

  return <MDBox>{renderCart()}</MDBox>;
}

export default DashboardPosProblem;
